module.exports = __webpack_public_path__ + "static/media/confirm-user.282a0454.svg";